import { Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';

export class CrabWiggle extends AnimationClip {
    public *execute(gameObject: GameObject): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        const crabLeftHand = gameObject.getChildByName('crabLeftHandSprite');
        const leftTransform = crabLeftHand.getComponent(TransformComponent);
        const crabRightHand = gameObject.getChildByName('crabRightHandSprite');
        const rightTransform = crabRightHand.getComponent(TransformComponent);
        const crabLeftHandTween = this.getTween(leftTransform);
        const crabRightHandTween = this.getTween(rightTransform);
        const rotationTween = this.getTween(transform);

        transform.rotation = Math.PI / 12;
        rotationTween
            .to({ rotation: -Math.PI / 12 }, 200)
            .yoyo(true)
            .repeat(Infinity)
            .start(this.elapsedTime);

        rightTransform.rotation = Math.PI / 8;
        leftTransform.rotation = -Math.PI / 8;

        crabLeftHandTween
            .easing(Easing.Cubic.InOut)
            .to({ rotation: Math.PI / 8 }, 100)
            .yoyo(true)
            .repeat(Infinity)
            .start(this.elapsedTime);
        crabRightHandTween
            .easing(Easing.Cubic.InOut)
            .to({ rotation: -Math.PI / 8 }, 100)
            .yoyo(true)
            .repeat(Infinity)
            .start(this.elapsedTime);

        // Loop.
        while (true) yield;
    }
}
